import { useEffect, useState } from "react";
import axios from "axios";
import { BookmarkPlus, Trash2 } from "lucide-react";
import { API } from "../lib/apiClient";

let cache = null;
const listeners = new Set();
const load = async () => { if (!cache) cache = (await axios.get(`${API}/coverage-templates`)).data; return cache; };
export const loadCoverageTemplates = async () => (cache = (await axios.get(`${API}/coverage-templates`)).data);
export const saveCoverageTemplates = async (list) => { await save(list); return cache; };
const save = async (list) => { cache = (await axios.put(`${API}/coverage-templates`, { templates: list })).data; listeners.forEach((f) => f(cache)); };

export function CoverageTemplatePicker({ company, branch, text, onPick, idx }) {
  const [all, setAll] = useState(cache || []);
  useEffect(() => { load().then(setAll).catch(() => {}); listeners.add(setAll); return () => listeners.delete(setAll); }, []);
  const list = all.filter((t) => (!t.company || t.company === company) && (!t.branch || t.branch === branch));
  const add = async () => {
    const name = window.prompt(`Şablon adı (${company || "tüm şirketler"} · ${branch || "tüm branşlar"})`, `${company || "Genel"} ${branch || ""}`.trim());
    if (!name) return;
    try { await save([...all, { company, branch, name, text }]); } catch { window.alert("Şablon kaydedilemedi"); }
  };
  const remove = async (id) => {
    if (!window.confirm("Bu teminat şablonu silinsin mi?")) return;
    await save(all.filter((t) => t.id !== id));
  };
  return (
    <div className="cov-tpl" data-testid={`coverage-templates-${idx}`}>
      {list.map((t) => (
        <span key={t.id} className="cov-chip">
          <button type="button" onClick={() => onPick(t.text)} data-testid={`coverage-template-use-${idx}-${t.id}`}>{t.name}</button>
          <button type="button" className="x" onClick={() => remove(t.id)} title="Sil" data-testid={`coverage-template-del-${idx}-${t.id}`}><Trash2 size={11} /></button>
        </span>
      ))}
      {(text || "").trim() && <button type="button" className="cov-save" onClick={add} data-testid={`coverage-template-save-${idx}`}><BookmarkPlus size={12} /> Şablon olarak kaydet</button>}
    </div>
  );
}
